import React from 'react';
import ReactDOM from 'react-dom';
import 'typeface-oswald';
import 'typeface-roboto';
import 'typeface-roboto-condensed';
import 'typeface-quantico';
import './index.css';
import "bootstrap/dist/css/bootstrap.min.css";
import App from './App';

ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById('root')
);

